import { CheckCircleIcon } from "@chakra-ui/icons";
import { IconButton, Text } from "@chakra-ui/react";
import { useState } from "react";
import { IoClose } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import CTable from "../../../components/Table/table";
import { openStudentReportModel, openChangeGroupModal } from "../../../modules/admin-modules/models/Actions";
import {
  approveStudentEnrollCourseRequest,
  rejectStudentEnrollCourseRequest,
  getAllEnrollCourseRequest,
} from "../../../modules/superadmin-modules/courses/Actions";
import ChangeGroupModal from "./change-group-modal";

const EnrollCourseRequestsTable = ({ courseId }) => {
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.superadminstudents.isLoading);
  const {
    enrollRequests,
    enrollCoursesCount,
    isLoading: loadingEnroll,
  } = useSelector((state) => state.courses);

  const [offset, setPage] = useState(0);
  const [size, setPerPage] = useState(10);
  const [pageNumber, setPageNumber] = useState(0);
  const [selected, setSelected] = useState({
    id: "",
  });
  const [selectedData, setSelectedData] = useState(null);
  
  const viewData = (data) => {
    setSelected(data);
  };
  const Data = enrollRequests?.map((data, index) => {
    return {
      ...data.user,
      index: `#${index + 1}`,
      id: data?.user?.id,
      student_name: (
        <Text
          cursor="pointer"
          onClick={() => dispatch(openStudentReportModel())}
        >
          {data?.user?.name}
        </Text>
      ),
      group_name: (
        <Text
          cursor="pointer"
          color="blue.500"
          _hover={{ textDecoration: "underline" }}
          onClick={() => {
            setSelectedData(data);
            dispatch(openChangeGroupModal());
          }}
        >
          {data?.student_group?.name || "No Group Selected"}
        </Text>
      ),
      phone: data?.user?.phone,

      approve: (
        <IconButton
          variant="outline"
          color="gray.600"
          border="0"
          aria-label="Call Sage"
          fontSize="20px"
          isLoading={selected.id == data?.id ? loadingEnroll : false}
          icon={<CheckCircleIcon color={"green"} />}
          onClick={() => {
            dispatch(
              approveStudentEnrollCourseRequest({
                data: {
                  student_id: data?.user?.id,
                  course_id: courseId,
                },
                action: () => dispatch(getAllEnrollCourseRequest()),
              })
            );
          }}
        />
      ),
      reject: (
        <IconButton
          variant="outline"
          color="gray.600"
          border="0"
          aria-label="Call Sage"
          fontSize="20px"
          // isLoading={selected.id == data?.id ? isRestrict : false}
          icon={<IoClose color={"red"} />}
          onClick={() => {
            dispatch(
              rejectStudentEnrollCourseRequest({
                data: {
                  student_id: data?.user?.id,
                  course_id: courseId,
                },   
                action: () => dispatch(getAllEnrollCourseRequest()),
              })
            );
          }}
        />
      ),
    };
  });
  const columns = [
    {
      Header: " #",
      accessor: "index",
    },
    {
      Header: "اسم الطالب",
      accessor: "student_name",
    },
    {
      Header: "المجموعة",
      accessor: "group_name",
    },
    {
      Header: " رقم الطالب",
      accessor: "phone",
    },
    {
      Header: "رقم المتابعة ",
      accessor: "mother_phone",
    },
    {
      Header: "اسم المستخدم",
      accessor: "user_name",
    },

    {
      Header: "Major",
      accessor: "major.name_ar",
    },
    {
      Header: "Grade",
      accessor: "grade.name_ar",
    },
    {
      Header: "",
      accessor: "approve",
    },
    {
      Header: "",
      accessor: "reject",
    },
  ];

  return (
    <>
      <CTable
        selectedData={viewData}
        Columns={columns}
        Data={Data || []}
        path={"openModel"}
        Title={``}
        subTitle=""
        btnTitle=""
        placeHolder=""
        noSearchBar={true}
        noFilter={true}
        footerBtnTitle
        filterList
        addButton
        addButtonTitle=""
        setPage={setPage}
        setPerPage={setPerPage}
        currentpage={pageNumber}
        setPageNumber={setPageNumber}
        noSecondSearchBar={true}
        isLoading={isLoading}
        perPage={size}
        totalPage={Math.ceil(enrollCoursesCount / 50)}
      />
      <ChangeGroupModal selectedData={selectedData} courseId={courseId} />
    </>
  );
};

export default EnrollCourseRequestsTable;
